module.exports = __webpack_public_path__ + "static/media/compressorIcon.3455857f.svg";